<app-category-update [category]="category"></app-category-update>
<app-category-delete [category]="category"></app-category-delete>